import { CircleAlert, CircleCheck, Info, X } from 'lucide-react';
import type { ReactNode } from 'react';
import type { ToastType } from '../../hooks/toastContext';
import '../../styles/toast.css';

type Props = {
  message: ReactNode | null;
  type?: ToastType;
  leaving?: boolean;
  onClose: () => void;
  onPointerEnter?: () => void;
  onPointerLeave?: () => void;
};

const TYPE_ICONS = {
  default: Info,
  success: CircleCheck,
  error: CircleAlert,
} as const;

export function ToastContainer({
  message,
  type = 'default',
  leaving = false,
  onClose,
  onPointerEnter,
  onPointerLeave,
}: Props) {
  if (!message) return null;

  const Icon = TYPE_ICONS[type];
  const typeClass = type === 'error' ? 'toast-error' : type === 'success' ? 'toast-success' : '';

  return (
    <div
      className={`toast-notification ${typeClass}${leaving ? ' toast-leaving' : ''}`}
      role="status"
      onMouseEnter={onPointerEnter}
      onMouseLeave={onPointerLeave}
    >
      <Icon className="toast-icon" size={17} aria-hidden="true" />
      <span>{message}</span>
      <button type="button" onClick={onClose} aria-label="閉じる">
        <X size={16} />
      </button>
    </div>
  );
}
